import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

class News extends Component {
  rendermessage(message) {
    var uuidv4 = require('uuid/v4');
    return (
      <li className="card-text" key={uuidv4()}>
        {message}
      </li>
    );
  }

  render() {
    const { t } = this.props;
    const messages = t('description');
    const messages2 = t('description2');
    const messages3 = t('description3');
    const messages4 = t('description4');

    return (
      <div className="container">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">{t('title')}</h5>
          </div>
          <div className="card-body">
            <h6 className="card-subtitle mb-2 text-muted">{t('subtitle')}</h6>
            {messages.split('<br>').map(message => this.rendermessage(message))}
          </div>
          <div className="card-body">
            <h6 className="card-subtitle mb-2 text-muted">{t('subtitle2')}</h6>
            {messages2
              .split('<br>')
              .map(message => this.rendermessage(message))}
          </div>
          <div className="card-body">
            <h6 className="card-subtitle mb-2 text-muted">{t('subtitle3')}</h6>
            {messages3.split('<br>').map(message => this.rendermessage(message))}
          </div>
          <div className="card-body">
            <h6 className="card-subtitle mb-2 text-muted">{t('subtitle4')}</h6>
            {messages4
              .split('<br>')
              .map(message => this.rendermessage(message))}
          </div>
        </div>
      </div>
    );
  }
}

News.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate('News')(News);



// WEBPACK FOOTER //
// ./src/components/News/index.js